import { FC } from 'react';
import { SelectProps } from 'antd';

import { Select } from '~/components';
import { useGetPayloadWithProvided } from '~/controllers/wizard';
import { useGetAntdLocale } from '~/hooks/i18nHooks';

const ActivitySelect: FC<SelectProps<any>> = (props) => {
  const locale = useGetAntdLocale();
  const payload = useGetPayloadWithProvided();

  const nameProp = locale && locale.locale.toLowerCase().indexOf('ar') >= 0 ? 'name' : 'nameEn';

  const options = (payload?.thiqahFullInfo?.activities || []).map((item: any) => {
    return { label: item.name, value: item.id, key: item.id };
  });

  return <Select loading={!payload} disabled={!payload} options={[ { label: 'Other', value: 'OTHER' }]} {...props} />;
};

export default ActivitySelect;
